import PropTypes from 'prop-types';
import React from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const GenericItem = ({
    headingText,
    title,
    url
}) => {
    // render
    return (
        <div className='relative'>
            <a
                className='block link-reset rich-text highlight-text type-style-3'
                dangerouslySetInnerHTML={{__html: headingText || title}}
                href={url} />
        </div>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

GenericItem.propTypes = {
    url: PropTypes.string,
    headingText: PropTypes.string,
    title: PropTypes.string
};

GenericItem.__typename = 'Generic';

export { GenericItem };

export default GenericItem;
